import { render, staticRenderFns } from "./DictItemList.vue?vue&type=template&id=d332903c&scoped=true&"
import script from "./DictItemList.vue?vue&type=script&lang=js&"
export * from "./DictItemList.vue?vue&type=script&lang=js&"
import style0 from "./DictItemList.vue?vue&type=style&index=0&id=d332903c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d332903c",
  null
  
)

export default component.exports